// 路由权限
import Vue from 'vue';
import router from './index';
import stort from '../store/index.js';





router.beforeEach((to, from, next) => {
	if (!stort.state.user.token) {
		// 未登录  页面是否需要登录 根据meta标签的   isLogin==true 是需要登录的
		if (to.meta.isLogin) {
			window.scrollTo(0, 0);
			// 根据目标路径前缀区分登录页：委托方个人中心跳委托方登录页，其余跳回收商登录页
			const loginPath = to.path.startsWith('/entrustmy') ? '/weiTuo' : '/huiShou';
			next(`${loginPath}?redirect=${encodeURIComponent(to.fullPath)}`)
		} else {
			if (to.path !== '/corpore/detail') {
				// 不需要登录的 进入列表页面需要 不直接到顶部
				window.scrollTo(0, 0); //跳转页面后直接到顶部
				next()
			} else {
				next()
			}
		}
	} else {
		// 用户已经登录  放行
		if (to.path === '/huiShou') {
			next('/my');
		} else {

			if (to.path !== '/corpore/detail') {
				// 已经登录过 进入列表页面需要 不直接到顶部
				window.scrollTo(0, 0); //跳转页面后直接到顶部
				next()
			} else {
				next()
			}
		}

	}
})